<ngx-spinner
  name="submit-forms"
  bdColor="rgba(255,255,255,0.5)"
  size="medium"
  color="#07B59A"
  type="ball-spin-clockwise"
  [fullScreen]="true"></ngx-spinner>

<div class="row">
  <div class="col-12">
    <form [formGroup]="form" (ngSubmit)="ngSubmit()">
      <div
        class="card border-top border-bottom-0 border-start-0 border-end-0 border-primary border-5 my-3">
        <div class="card-body">
          <div class="row">
            <div class="col-12 accordion-flush">
              <ng-container formArrayName="sections">
                <ngb-accordion
                  #acc="ngbAccordion"
                  [activeIds]="activeIds"
                  [closeOthers]="false">
                  <ngb-panel
                    *ngFor="let s of sections; let i = index"
                    id="section-{{ i }}">
                    <ng-container [formGroupName]="i">
                      <ng-template ngbPanelTitle class="text-black">
                        <b>{{ s.label }}</b>
                      </ng-template>
                      <ng-template ngbPanelContent>
                        <app-section
                          [form]="getSection(i)"
                          [section]="s"></app-section>
                      </ng-template>
                    </ng-container>
                  </ngb-panel>
                </ngb-accordion>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
